import { useEffect } from "react";
import { collectAllAssetUrls } from "../lib/assetUrls";
import { preloadAssets } from "../lib/preloadAssets";

export const AssetPreloader = () => {
	useEffect(() => {
		const start = () => {
			collectAllAssetUrls()
				.then((urls) =>
					preloadAssets(urls, {
						ignoreErrors: true,
					})
				)
				.catch(() => {
					// Silently ignore preloading errors
				});
		};

		// Defer to idle time if possible to avoid blocking first render
		// @ts-ignore
		if (typeof window !== "undefined" && window.requestIdleCallback) {
			// @ts-ignore
			window.requestIdleCallback(start);
		} else {
			setTimeout(start, 0);
		}
	}, []);

	return null;
};


